<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>

        <!-- <div class="col text-right">
          <base-button type="primary" size="sm">ดูทั้งหมด</base-button>
        </div> -->
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-striped"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <!-- <th class="text-center" style="font-size: 14px;">รหัสเครื่อง</th> -->
          <th class="text-center" style="font-size: 14px;">ชื่อเครื่อง</th>
          <!-- <th class="text-center" style="font-size: 14px;">จำนวนการใช้งาน</th>
          <th class="text-center" style="font-size: 14px;">รายได้ (ไม่รวมค่าบริการ) </th>
          <th class="text-center" style="font-size: 14px;">สถานะ</th>
          <th class="text-center" style="font-size: 14px;">ตั้งค่า</th> -->
          <th class="text-center" style="font-size: 14px;">โหมด</th>
          <!-- <th></th> -->
        </template>

        <template slot-scope="{row}">

          <td class="text-center">
            {{row.name_desc}} <div style="font-size: 9px; color: #C0C0C0;">({{row.name}})</div>
          </td>
          <td class="text-center">
            <div class="form-group" v-for="item in row.modes">
              <button class="btn btn-outline-primary" type="button" name="button" v-on:click="open(row.name, item.mode_name);">
                {{item.mode_desc}}
              </button>
            </div>
            <button class="btn btn-outline-danger" type="button" name="button" v-on:click="close(row.name);">
              ปิดเครื่อง
            </button>
          </td>
        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <!-- <base-pagination total="30"></base-pagination> -->
    </div>

  </div>
</template>
<script>
  import JwService from '../../service/justwash';

  export default {
    name: 'washing-machine-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        tableData: null
      }
    },
    methods: {
      open:function(washing_machine_id, mode_name) {
        // alert(mode_name);
        // console.log(this.tableData.modes.mode_name);
        var x = confirm('คุณแน่ใจหรือยังว่าต้องการเปิดเครื่องนี้?');
        if (x == true) {
          axios({
            method: 'post',
            url: JwService.getAPI()+'/api/method/justwash.OwnerApi.ManualWashing',
            data: {
              washing_machine_id: washing_machine_id,
              mode: mode_name
            },
            headers: {
              'Authorization' : 'Token '+localStorage.getItem('accessToken')
            }
          }).then((response) => {
            if (response.data.message.status == true) {
              // this.tableData = response.data.message.data.data;
              // for (let idx in  response.data.message.data.data) {
              //   console.log(idx);
              // }
              // console.log(this.tableData);
              // console.log(response.data.message.data);
            } else {
              this.$router.push('/login');
            }
          }).catch(error => {
            console.log(error);
            this.$router.push('/login');
          });
          alert('สั่งเปิดเครื่องแล้ว');
        }
      },
      close:function(washing_machine_id) {
        var x = confirm('คุณแน่ใจหรือยังว่าต้องการปิดเครื่องนี้?');
        if (x == true) {
          axios({
            method: 'post',
            url: JwService.getAPI()+'/api/method/justwash.OwnerApi.CloseWashing',
            data: {
              washing_machine_id: washing_machine_id
            },
            headers: {
              'Authorization' : 'Token '+localStorage.getItem('accessToken')
            }
          }).then((response) => {
            if (response.data.message.status == true) {
              // this.tableData = response.data.message.data.data;
              // for (let idx in  response.data.message.data.data) {
              //   console.log(idx);
              // }
              // console.log(this.tableData);
              // console.log(response.data.message.data);
            } else {
              this.$router.push('/login');
            }
          }).catch(error => {
            console.log(error);
            this.$router.push('/login');
          });
          alert('สั่งปิดเครื่องแล้ว');
        }
      }
    },
    mounted() {
      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.WashingMachinesManual',
        data: {
          manual_washing : true,
          washing_machine_id : ''
        },
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status == true) {
          this.tableData = response.data.message.data.data;
          // for (let idx in  response.data.message.data.data) {
          //   console.log(idx);
          // }
          // console.log(this.tableData);
          // console.log(response.data.message.data);
        } else {
          this.$router.push('/login');
        }
      }).catch(error => {
        console.log(error);
        this.$router.push('/login');
      });
    }
  }
</script>
<style>
</style>
